export default {
  data: () => ({
    translations: {
      range: {
        el: '',
        en: 'Range',
        it: '',
      },
      date: {
        el: 'Ημερομηνία',
        en: 'Date',
        it: 'Data',
      },
      storeId: {
        el: '',
        en: 'Store ID',
        it: '',
      },
      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Points',
      },
      cashback: {
        el: 'Cashback',
        en: 'Cashback',
        it: 'Cashback',
      },
      name: {
        el: 'Όνομα',
        en: 'Name',
        it: 'Name',
      },
      address: {
        el: 'Διεύθυνση',
        en: 'Address',
        it: 'Indirizzo',
      },
      totalRedeemCoupons: {
        el: '',
        en: 'Total Redeem Coupons',
        it: '',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
    },
  }),
};
